import { CommonModule } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, Signal, ViewChild, WritableSignal, computed, effect, signal } from '@angular/core';
import { PageComponent } from "src/app/layout/pages/page/page.component";
import { MyButtonComponent } from "../../../shared/components/buttons/my-button/my-button.component";
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { IApiKey } from "../models/api-key.model";
import { AmministrazioneService } from "../aministrazione.service";
import {MatFormFieldModule} from '@angular/material/form-field';
import { DialogService } from "src/app/core/services/dialog.service";
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatButtonModule} from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import {MatGridListModule} from '@angular/material/grid-list';
@Component({
    selector: 'app-amministrazione-enti-page',
    standalone: true,
    templateUrl: './amministrazione-enti-page.component.html',
    styleUrls: ['./amministrazione-enti-page.component.css'],
    imports: [
        CommonModule,
        PageComponent,
        MyButtonComponent,
        MatMenuModule,
        MatIconModule,
        ClipboardModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatGridListModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmministrazioneEntiPageComponent implements AfterViewInit {
    datiApiKey: WritableSignal<IApiKey | null>=signal(null);
    private destroy$ = new Subject<void>();

    constructor(
        private dialogService: DialogService,
        private readonly amministrazioneService: AmministrazioneService,
    ) {
      
       this.refreshApiKeys()
    }

    ngAfterViewInit() {
        // Any initialization logic that needs the view can go here.
    }

    onDeleteAllClick() {
        this.amministrazioneService.deleteClient().pipe(takeUntil(this.destroy$)).subscribe(value => {
            if (value) {
                this.dialogService.success(`L' API KEY è stata eliminata con successo.`, true);
                this.refreshApiKeys();
            }
        });
    }

    createApi() {
        this.amministrazioneService.createClient().pipe(takeUntil(this.destroy$)).subscribe(value => {
            if(value){
                this.dialogService.success(`L' API KEY è stata creata con successo.`, true);
                this.refreshApiKeys();
            }

        });
    }

    refreshApiKeys() {
        this.amministrazioneService.get().pipe(takeUntil(this.destroy$)).subscribe(apiKey => {
            this.datiApiKey.set(apiKey);
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
